/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getHospitalBills } from 'app/entities/hospital-bill/hospital-bill.reducer';
import { getEntities as getPatientCategories } from 'app/entities/patient-category/patient-category.reducer';
import { getEntities as getHospitalPayments } from 'app/entities/hospital-payment/hospital-payment.reducer';
import { getEntities as getPaymentSchemes } from 'app/entities/payment-scheme/payment-scheme.reducer';
import { BillType } from 'app/shared/model/enumerations/bill-type.model';
import { PaymentMethod } from 'app/shared/model/enumerations/payment-method.model';
import { PaymentStatus } from 'app/shared/model/enumerations/payment-status.model';
import { createEntity, getEntity, reset, updateEntity } from './hospital-bill-item.reducer';

export const HospitalBillItemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const hospitalBills = useAppSelector(state => state.hospitalBill.entities);
  const patientCategories = useAppSelector(state => state.patientCategory.entities);
  const hospitalPayments = useAppSelector(state => state.hospitalPayment.entities);
  const paymentSchemes = useAppSelector(state => state.paymentScheme.entities);
  const hospitalBillItemEntity = useAppSelector(state => state.hospitalBillItem.entity);
  const loading = useAppSelector(state => state.hospitalBillItem.loading);
  const updating = useAppSelector(state => state.hospitalBillItem.updating);
  const updateSuccess = useAppSelector(state => state.hospitalBillItem.updateSuccess);
  const billTypeValues = Object.keys(BillType);
  const paymentMethodValues = Object.keys(PaymentMethod);
  const paymentStatusValues = Object.keys(PaymentStatus);

  const handleClose = () => {
    navigate(`/hospital-bill-item${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getHospitalBills({}));
    dispatch(getPatientCategories({}));
    dispatch(getHospitalPayments({}));
    dispatch(getPaymentSchemes({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.remainingQty !== undefined && typeof values.remainingQty !== 'number') {
      values.remainingQty = Number(values.remainingQty);
    }
    if (values.rate !== undefined && typeof values.rate !== 'number') {
      values.rate = Number(values.rate);
    }
    if (values.discountRate !== undefined && typeof values.discountRate !== 'number') {
      values.discountRate = Number(values.discountRate);
    }
    if (values.marginRate !== undefined && typeof values.marginRate !== 'number') {
      values.marginRate = Number(values.marginRate);
    }
    if (values.netRate !== undefined && typeof values.netRate !== 'number') {
      values.netRate = Number(values.netRate);
    }
    if (values.grossValue !== undefined && typeof values.grossValue !== 'number') {
      values.grossValue = Number(values.grossValue);
    }
    if (values.discount !== undefined && typeof values.discount !== 'number') {
      values.discount = Number(values.discount);
    }
    if (values.tax !== undefined && typeof values.tax !== 'number') {
      values.tax = Number(values.tax);
    }
    if (values.netValue !== undefined && typeof values.netValue !== 'number') {
      values.netValue = Number(values.netValue);
    }
    if (values.taxPlusNetValue !== undefined && typeof values.taxPlusNetValue !== 'number') {
      values.taxPlusNetValue = Number(values.taxPlusNetValue);
    }
    if (values.marginValue !== undefined && typeof values.marginValue !== 'number') {
      values.marginValue = Number(values.marginValue);
    }
    if (values.adjustedValue !== undefined && typeof values.adjustedValue !== 'number') {
      values.adjustedValue = Number(values.adjustedValue);
    }
    values.microSec = convertDateTimeToServer(values.microSec);
    values.timestampEntry = convertDateTimeToServer(values.timestampEntry);
    values.lastUpdated = convertDateTimeToServer(values.lastUpdated);
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.multiplier !== undefined && typeof values.multiplier !== 'number') {
      values.multiplier = Number(values.multiplier);
    }
    if (values.roundOffVal !== undefined && typeof values.roundOffVal !== 'number') {
      values.roundOffVal = Number(values.roundOffVal);
    }

    const entity = {
      ...hospitalBillItemEntity,
      ...values,
      bill: hospitalBills.find(it => it.id.toString() === values.bill?.toString()),
      patientCategory: patientCategories.find(it => it.id.toString() === values.patientCategory?.toString()),
      hospitalPayment: hospitalPayments.find(it => it.id.toString() === values.hospitalPayment?.toString()),
      scheme: paymentSchemes.find(it => it.id.toString() === values.scheme?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          microSec: displayDefaultDateTime(),
          timestampEntry: displayDefaultDateTime(),
          lastUpdated: displayDefaultDateTime(),
        }
      : {
          billType: 'OP',
          paymentMethod: 'CASH',
          paymentStatus: 'ENTERED',
          ...hospitalBillItemEntity,
          microSec: convertDateTimeFromServer(hospitalBillItemEntity.microSec),
          timestampEntry: convertDateTimeFromServer(hospitalBillItemEntity.timestampEntry),
          lastUpdated: convertDateTimeFromServer(hospitalBillItemEntity.lastUpdated),
          bill: hospitalBillItemEntity?.bill?.id,
          patientCategory: hospitalBillItemEntity?.patientCategory?.id,
          hospitalPayment: hospitalBillItemEntity?.hospitalPayment?.id,
          scheme: hospitalBillItemEntity?.scheme?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.hospitalBillItem.home.createOrEditLabel" data-cy="HospitalBillItemCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.hospitalBillItem.home.createOrEditLabel">Create or edit a HospitalBillItem</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="hospital-bill-item-id"
                  label={translate('tinyMedicRestApp.hospitalBillItem.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillItem.descreption')}
                id="hospital-bill-item-descreption"
                name="descreption"
                data-cy="descreption"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillItem.remainingQty')}
                id="hospital-bill-item-remainingQty"
                name="remainingQty"
                data-cy="remainingQty"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillItem.rate')}
                id="hospital-bill-item-rate"
                name="rate"
                data-cy="rate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillItem.discountRate')}
                id="hospital-bill-item-discountRate"
                name="discountRate"
                data-cy="discountRate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillItem.marginRate')}
                id="hospital-bill-item-marginRate"
                name="marginRate"
                data-cy="marginRate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillItem.netRate')}
                id="hospital-bill-item-netRate"
                name="netRate"
                data-cy="netRate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillItem.grossValue')}
                id="hospital-bill-item-grossValue"
                name="grossValue"
                data-cy="grossValue"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillItem.discount')}
                id="hospital-bill-item-discount"
                name="discount"
                data-cy="discount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillItem.tax')}
                id="hospital-bill-item-tax"
                name="tax"
                data-cy="tax"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillItem.netValue')}
                id="hospital-bill-item-netValue"
                name="netValue"
                data-cy="netValue"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillItem.taxPlusNetValue')}
                id="hospital-bill-item-taxPlusNetValue"
                name="taxPlusNetValue"
                data-cy="taxPlusNetValue"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillItem.marginValue')}
                id="hospital-bill-item-marginValue"
                name="marginValue"
                data-cy="marginValue"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillItem.adjustedValue')}
                id="hospital-bill-item-adjustedValue"
                name="adjustedValue"
                data-cy="adjustedValue"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillItem.billType')}
                id="hospital-bill-item-billType"
                name="billType"
                data-cy="billType"
                type="select"
              >
                {billTypeValues.map(billType => (
                  <option value={billType} key={billType}>
                    {translate(`tinyMedicRestApp.BillType.${billType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillItem.active')}
                id="hospital-bill-item-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillItem.microSec')}
                id="hospital-bill-item-microSec"
                name="microSec"
                data-cy="microSec"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillItem.timestampEntry')}
                id="hospital-bill-item-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillItem.lastUpdated')}
                id="hospital-bill-item-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillItem.cursor')}
                id="hospital-bill-item-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillItem.miscellaneous')}
                id="hospital-bill-item-miscellaneous"
                name="miscellaneous"
                data-cy="miscellaneous"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillItem.multiplier')}
                id="hospital-bill-item-multiplier"
                name="multiplier"
                data-cy="multiplier"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillItem.paymentMethod')}
                id="hospital-bill-item-paymentMethod"
                name="paymentMethod"
                data-cy="paymentMethod"
                type="select"
              >
                {paymentMethodValues.map(paymentMethod => (
                  <option value={paymentMethod} key={paymentMethod}>
                    {translate(`tinyMedicRestApp.PaymentMethod.${paymentMethod}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillItem.paymentStatus')}
                id="hospital-bill-item-paymentStatus"
                name="paymentStatus"
                data-cy="paymentStatus"
                type="select"
              >
                {paymentStatusValues.map(paymentStatus => (
                  <option value={paymentStatus} key={paymentStatus}>
                    {translate(`tinyMedicRestApp.PaymentStatus.${paymentStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillItem.roundOffVal')}
                id="hospital-bill-item-roundOffVal"
                name="roundOffVal"
                data-cy="roundOffVal"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalBillItem.chargedItem')}
                id="hospital-bill-item-chargedItem"
                name="chargedItem"
                data-cy="chargedItem"
                type="text"
              />
              <ValidatedField
                id="hospital-bill-item-bill"
                name="bill"
                data-cy="bill"
                label={translate('tinyMedicRestApp.hospitalBillItem.bill')}
                type="select"
              >
                <option value="" key="0" />
                {hospitalBills
                  ? hospitalBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="hospital-bill-item-patientCategory"
                name="patientCategory"
                data-cy="patientCategory"
                label={translate('tinyMedicRestApp.hospitalBillItem.patientCategory')}
                type="select"
              >
                <option value="" key="0" />
                {patientCategories
                  ? patientCategories.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="hospital-bill-item-hospitalPayment"
                name="hospitalPayment"
                data-cy="hospitalPayment"
                label={translate('tinyMedicRestApp.hospitalBillItem.hospitalPayment')}
                type="select"
              >
                <option value="" key="0" />
                {hospitalPayments
                  ? hospitalPayments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="hospital-bill-item-scheme"
                name="scheme"
                data-cy="scheme"
                label={translate('tinyMedicRestApp.hospitalBillItem.scheme')}
                type="select"
              >
                <option value="" key="0" />
                {paymentSchemes
                  ? paymentSchemes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/hospital-bill-item" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default HospitalBillItemUpdate;
